import { useOrganizationInvitation } from '@openclassrooms/data-connect-web/organizations';
import { ROUTES } from '@openclassrooms/routing';

import useAuthParams from './useAuthParams';

export default function useInvitation() {
  const { context, invitationId, isLoginScreen, isRegisterByEmail, isRegisterScreen, token } =
    useAuthParams();
  const isInvitation = Boolean(invitationId && token);

  const fetchEnabled = isInvitation && (isLoginScreen || isRegisterByEmail);

  const { data: invitationData, isInitialLoading: isLoadingInvitation } = useOrganizationInvitation(
    { id: invitationId, queryParams: { token } },
    { enabled: fetchEnabled }
  );

  const isLoading = isLoadingInvitation;

  const redirectTo =
    isInvitation && isRegisterScreen ? ROUTES.AUTH.REGISTER_EMAIL + location.search : null;

  return {
    isInvitation,
    redirectTo,
    invitationData,
    isLoading,
    context,
  };
}
